import _ from 'lodash';
import angular from 'angular';
import moment from 'moment';
import sanitize from 'sanitize-filename';
import logger from '../../../shared/logger';

export function ProfileService(
    RenderService,
    PrintService,
    PositionService,
    DownloadService,
    EnvSettings,
    $sce,
    $compile,
    $rootScope,
    EmployerService,
    NotificationService,
) {
    const downloadPdfFromHtmlElementPromise = (htmlElement,
        {
            employerName = '',
            jobTitle = '',
            candidateName,
            showName,
            fileName = getFileName({ employerName, jobTitle, candidateName, showName }) },
    ) => {
        const fileType = 'application/pdf';

        return RenderService.renderToPdf({ htmlElement, webApp: true })
            .then(pdfFile => DownloadService.downloadFile(pdfFile, { fileName: sanitize(fileName), fileType }))
            .catch(err => logger.error(err));
    };

    const getFileName = ({ candidateName = '', jobTitle = '', employerName = '', showName = false }) => {
        const SEPARATOR = ' - ';
        const fileNameParts = [];
        const formattedDate = getFormattedDate();
        const talenyaPrefix = 'TALENYA';

        fileNameParts.push(talenyaPrefix);

        if (showName) {
            fileNameParts.push(candidateName);
        }
        fileNameParts.push(jobTitle, employerName, formattedDate);

        const fileName = fileNameParts.filter(Boolean).join(SEPARATOR);
        const fileExtension = 'pdf';
        return sanitize(`${fileName}.${fileExtension}`);
    };

    const getFormattedDate = () => moment.utc().format('MM_DD_YY');

    const printCandidatePage = ({ requesterUserType, requesterUserId, positionId, workflowStep, talentId, mode, profileType }) => {
        const candidatePageUrl = `print/${requesterUserType}/${requesterUserId}/position/${positionId}/workflowStep/${workflowStep}/${profileType}/${talentId}?printType=default&printMode=${mode}`;

        return window.open($sce.trustAsResourceUrl(`${EnvSettings.WebAppUrl}/${candidatePageUrl}`));
    };

    const downloadCandidatePageAsPdf =
        async ({
            requesterUserType,
            requesterUserId,
            positionId,
            workflowStep,
            talentId,
            mode,
            candidateName,
            showName,
            profileType,
            fileName,
        }) => {
            const candidatePageUrl = `print/${requesterUserType}/${requesterUserId}/position/${positionId}/workflowStep/${workflowStep}/${profileType}/${talentId}?printType=pdf&printMode=${mode}`;
            try {
                const html = await getRenderedProfile(candidatePageUrl);

                const { result: positionData } = await PositionService.getPosition(positionId);
                const { result: employerData } = await EmployerService.getEmployer(positionData.employerId);

                const employerName = _.get(employerData, 'name', '');
                const jobTitle = _.get(positionData, 'jobTitle', '');


                return downloadPdfFromHtmlElementPromise(html, { employerName, jobTitle, candidateName, showName, fileName });
            } catch (err) {
                logger.error(err);
                NotificationService.error('PDF Export failed');
            }
        };

    const getRenderedProfile = pageUrl => new Promise((resolve) => {
        let component;
        const $newScope = $rootScope.$new();
        const template = `
                <web-app-adapter
                    url="pageUrl"
                    style="display: none"
                    on-data-loaded="onDataLoaded(eventData)"
                >
                </web-app-adapter>
            `;
        const onDataLoaded = (eventData) => {
            document.body.removeChild(component);
            resolve(eventData.html);
        };

        $newScope.onDataLoaded = onDataLoaded;
        $newScope.pageUrl = pageUrl;
        component = $compile(template)($newScope)[0];

        document.body.appendChild(component);
    });

    return {
        printCandidatePage,
        downloadCandidatePageAsPdf,
    };
}

angular.module('TALENYA-FE').factory('ProfileService', ProfileService);
